import React, { useEffect, useState } from 'react';
import { ListingTable } from './ListTable';
import { ChannelIconData, fetchChannel } from '@/core/services/ChannelsService';
import { ScheduledPostStatus, cancelScheduledContent } from '@/core/services/SacReplyService';
import { Paths } from '@/routes/paths/Paths';
import './ListScheduledContent.scss';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/core/components/ToastProvider/ToastProvider';
import { useTranslation } from 'react-i18next';

export const ListScheduledContent: React.FC = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [instagram, setInstagram] = useState<ChannelIconData | undefined>(undefined);
  const [refreshKey, setRefreshKey] = useState(0);
  const { t } = useTranslation();

  const statusLabel = 'Status';
  const heading = [t('table.channels'), t('table.media'), t('table.caption'), t('table.account'), t('table.contentType'), statusLabel, t('table.publishedAt'), t('table.actions')];
  const statusHeaderLabel = statusLabel;
  
  useEffect(() => {
    async function loadChannel() {
      setInstagram(await fetchChannel('instagram'));
    }

    loadChannel();
  }, []);

  const handleDelete = async (item: any) => {
    const scheduledContentId = item._id;
    const pageId = item.page_id;

    if (!scheduledContentId || !pageId) {
      console.error('Invalid Content Ids', item);
      showToast({
        variant: 'error',
        title: t('scheduleSection.errorInvalidData'),
        text: t('scheduleSection.errorInvalidDataText'),
        icon: 'error'
      });
      return;
    }
    
    try {
      await cancelScheduledContent('instagram', pageId, scheduledContentId);
      showToast({
        variant: 'success',
        title: t('scheduleSection.contentDeleted'),
        text: t('scheduleSection.contentDeletedText'),
        icon: 'check-circle'
      });
      setRefreshKey(prev => prev + 1);

    } catch (error) {
      console.error('Error canceling scheduled content:', error);
      showToast({
        variant: 'error',
        title: t('scheduleSection.errorCancelingContent'),
        text: t('scheduleSection.errorCancelingContentText'),
        icon: 'error',
      });
    }
  };
  return (
    <main role="main" aria-labelledby="main-heading">
      <div className="header">
        <bds-typo id="main-heading" variant="fs-24" bold="bold">
          {t('postAndSchedule')}
        </bds-typo>
      </div>
      <bds-paper class="container" elevation="none" width="auto">
        <div className="container-header">
          <div className="title-subtitle">
          <bds-typo variant="fs-20" bold="bold">
            {t('contents')}
          </bds-typo>
          <bds-typo class="profile-section_header-subtitle" tag="p" variant="fs-12">
            {t('checkScheduledPublished')}
          </bds-typo>
          </div>
          <bds-button onClick={() => navigate(Paths.createScheduledContent)} variant="primary">
            {t('createNewPublication')}
          </bds-button>
        </div>
        <bds-tab-group align="center" content-scrollable="true" role="tablist" aria-label={t('common.contentTypes')}>
          <bds-tab-item label={t('scheduled')} role="tab" aria-selected="true" aria-controls="scheduled-panel">
            <div id="scheduled-panel" role="tabpanel" aria-labelledby="scheduled-tab">
              <ListingTable
                heading={heading.filter(item => item !== statusHeaderLabel)}
                status={ScheduledPostStatus.SCHEDULED}
                channel={instagram}
                onDelete={handleDelete} 
                refreshKey={refreshKey}
              />
            </div>
          </bds-tab-item>
          <bds-tab-item label={t('published')} role="tab" aria-selected="false" aria-controls="published-panel">
            <div id="published-panel" role="tabpanel" aria-labelledby="published-tab">
              <ListingTable heading={heading} status={ScheduledPostStatus.PUBLISHED} channel={instagram} />
            </div>
          </bds-tab-item>
        </bds-tab-group>
      </bds-paper>
    </main>
  );
};
